var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-section-title",class:{
    'form-section-title--block': _vm.block,
    'form-section-title--dark': _vm.dark,
    'form-section-title--required': _vm.required,
  },style:(("--text-transform: " + _vm.transform))},[_c('div',{staticClass:"form-section-title__content"},[_vm._t("default"),(_vm.required)?_c('div',{staticClass:"form-section-title__asterix-wrapper"},[_c('RequiredAsterix')],1):_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }